import React, { useMemo } from "react";
import cx from "components/src/utils/cx";
import { formatString } from "../js/formatString";
import { EventDetails } from "components-sbk/src/components/EventDetails/EventDetails";
import type { LegOptionsType, LegType } from "../types";

export const LegText = ({
  isTitle,
  isEventDetails,
  boldText,
  hideBullet,
  showBulletOnly,
  text,
  characterLimit,
  eventDetails,
  isSingleLeg,
  isFirstLeg,
  hasEventDetails,
  description,
  legTestId,
  children,
}: Partial<LegType> & Partial<LegOptionsType>) => {
  
  const _elementTiming = isTitle ? { elementtiming: "quick_picks" } : {};
  const _text = useMemo(()=>{
    return text ? formatString(text, characterLimit) : ""
  },[text]);

  if (isEventDetails) {
    return (
      <li
        className={cx(
          {
            "-cui-ml-6": !!hideBullet,
          },
          "cui__leg-date cui-flex cui-items-center cui-text-fg-default focus:cui-outline-none focus-visible:cui-ring-1 focus-visible:cui-ring-offset-2 focus-visible:cui-ring-fg-focus"
        )}
        aria-hidden={showBulletOnly ? "true" : "false"}
        tabIndex={showBulletOnly ? -1 : 0}
      >
        <EventDetails
          className="cui-pt-2px cui-pb-1"
          noPad
          {...eventDetails}
          textSize="heading-sm"
          noMinHeight
        />
      </li>
    );
  }

  return (
    <li
      className={cx(
        {
          "display-sm-bold": !!isTitle,
          "body-sm": !!!boldText && !isTitle && !!!isSingleLeg,
          "body-sm-bold": !!boldText && !isTitle && !!!isSingleLeg,
          "heading-md-bold": !!isSingleLeg,
          "cui-mt-lg": !!isSingleLeg && !hasEventDetails,
          "cui-mt-2xs": !!isSingleLeg && !!hasEventDetails,
          "-cui-ml-6": !!hideBullet || (!!isSingleLeg && !!hasEventDetails)
        },
        "cui-flex cui-flex-col cui-items-start cui-text-fg-default focus:cui-outline-none focus-visible:cui-ring-1 focus-visible:cui-ring-offset-2 focus-visible:cui-ring-fg-focus"
      )}
      aria-hidden={showBulletOnly ? "true" : "false"}
      tabIndex={showBulletOnly ? -1 : 0}
      //@ts-ignore
      {..._elementTiming}
      data-testid={legTestId}
    >
      {!showBulletOnly && text ? <span className={isFirstLeg ? "cui-inline-block cui-max-w-[80%]" : ""}>{_text}</span> : children}
      {description ? (
        <span className={`cui-text-fg-moderate body-sm cui-mt-2xs`}>{description}</span>
      ) : null}
    </li>
  );
};
